module.exports = __webpack_public_path__ + "img/aks8s-qq8xc.2a4436f3.png";